export enum GALLERY_ACTION_TYPES {
  FETCH_DATA = "gallery/FETCH_DATA",
  SET_DATA = "gallery/SET_DATA",
  SET_IS_LOADING = "gallery/SET_IS_LOADING",
}